var map = {
	"./balraj.jpg": 19103,
	"./geetha.jpg": 89209,
	"./karthikeyan.jpg": 55554,
	"./kowshalya.jpg": 54910,
	"./krishnamoorthy.jpg": 54125,
	"./krishnaveni.jpg": 41245,
	"./manikandan.jpg": 22521,
	"./manjularani.jpg": 14193,
	"./nirmaladevi.jpg": 66922,
	"./palanisamy.jpg": 98706,
	"./prabhakaran.jpg": 28694,
	"./revathi.jpg": 8278,
	"./sathishkumar.jpg": 34715,
	"./srinivasan.jpg": 5777,
	"./tamilsai.jpg": 55049,
	"./yoghananthan.jpg": 58171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94627;